module.exports = __webpack_public_path__ + "static/media/MSME.185e3428.jpeg";